import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { InputField, urlEncode } from './common';

const phoneRegExp = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;

const schema = yup.object().shape({
  name: yup.string().ensure().trim().required('Namn är ett obligatoriskt fält'),
  email: yup
    .string()
    .ensure()
    .trim()
    .email('Måste vara en giltig e-post adress')
    .required('E-post är ett obligatoriskt fält'),
  company: yup.string().ensure().trim().required('Företag är ett obligatoriskt fält'),
  phone: yup.string().required('Mobilnummer är ett obligatoriskt fält').matches(phoneRegExp, 'Ange ett giltig mobilnummer')
});

const EmployerForm = () => {
  const { register, handleSubmit, reset, formState: { errors } } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = data => {
    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: urlEncode({
        'form-name': 'employer',
        ...data
      })
    }).then(() => {
      alert('Skickat!');
      reset();
    });
  };

  return (
    <form
      className='flex flex-col space-y-4 items-center py-4'
      onSubmit={handleSubmit(onSubmit)}
      method='post'
      data-netlify-honepot='bot-field'
      data-netlify='true'
      name='employer'
      action='/'>
      <div className='flex flex-col space-y-4 items-center justify-center w-full text-black'>
        <div hidden>
          <label>
            Fyll inte i detta: <input name='bot-field' {...register('bot-field')} />
          </label>
        </div>
        <div className='flex flex-col space-y-4 lg:space-y-0 w-full'>
          <InputField
            name='name'
            placeholder='Namn'
            label='Namn*'
            register={register}
            errors={errors}
            className='input-border p-2'
          />
          <InputField
            name='company'
            placeholder='Företagsnamn'
            label='Företag*'
            register={register}
            errors={errors}
            className='input-border p-2'
          />
          <InputField
            name='email'
            placeholder='E-post adress'
            label='E-post*'
            type='email'
            register={register}
            errors={errors}
            className='input-border p-2'
          />
          <InputField
            name='phone'
            placeholder='Mobilnummer'
            label='Mobilnummer*'
            register={register}
            errors={errors}
            className='input-border p-2'
          />
        </div>
      </div>
      <button
        className='btn-primary text-2xl'
        type='submit'>
        Skicka
      </button>
    </form>
  );
};

export default EmployerForm;
